import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material";
import { FormAutoComplete, FormNumField, FormTextField } from "./FormKomponents";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";

const program = "KMPAPI";

export function KabelFastDialog({ open = false, optionen, handleClose, accessToken, client }) {
  const { t } = useTranslation();
  const [formValues, setFormValues] = useState(() => {
    try {
      const stored = sessionStorage.getItem("KabelFastForm");
      console.log(stored)
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {
        ID: nextKey,
        startStandort: null,
        startRaum: null,
        startEinheit: null,
        startKategorie: null,
        startFhw: null,
        startPort: null,
        zielStandort: null,
        zielRaum: null,
        zielEinheit: null,
        zielKategorie: null,
        zielFhw: null,
        zielPort: null,
        art: null,
        laenge: "00.0",
        startStecker: null,
        zielStecker: null,
        spez: null,
        virtuell: "0",
      };
    }
  });
  const [isLoading, setIsLoading] = useState(false);
  const [nextKey, setNextKey] = useState("");
  const { showSuccessMessage, showErrorMessage } = useMessage();
  const dialogVersion = "2";
  const disabled = false;

  const INFO_KEY = "cableDialogInfoHidden";
  const [showInfo, setShowInfo] = useState(() => localStorage.getItem(INFO_KEY) !== "true");

  const hideInfo = () => {
    localStorage.setItem(INFO_KEY, "true");
    setShowInfo(false);
  };

  // Optionen für Select Felder
  const einheitenOptions = useMemo(() => {
    return optionen?.einheiten;
  });

  const artenOptions = useMemo(() => {
    return optionen?.art;
  });

  const kategorieOptions = useMemo(() => {
    return optionen?.kategorie;
  });

  const spezOptions = useMemo(() => {
    return optionen?.spez;
  });

  const standortOptions = useMemo(() => {
    return optionen?.standort;
  });

  const steckerOptions = useMemo(() => {
    return optionen?.stecker;
  });

  // Filtern der Option passend zu Auswahl der Kategorie
  const deviceOptionsStart = useMemo(() => {
    if (!optionen || !formValues.startKategorie) return [];
    return optionen?.device?.filter((device) => device.kat === formValues.startKategorie);
  }, [optionen, formValues.startKategorie, kategorieOptions]);

  const deviceOptionsZiel = useMemo(() => {
    if (!optionen || !formValues.zielKategorie) return [];
    return optionen?.device?.filter((device) => device.kat === formValues.zielKategorie);
  }, [optionen, formValues.zielKategorie, kategorieOptions]);

  const virtuellOptionen = useMemo(() => {
    return [
      { value: "0", label: "Nicht Virtuell" },
      { value: "1", label: "Virtuell" },
    ];
  });

  // ----------------------------------------------------
  // -----------Allgemeine funktionen--------------------
  // ----------------------------------------------------
  useEffect(() => {
    if (optionen?.nextKey) {
      setNextKey(optionen?.nextKey);
    }
  }, [optionen]);

  useEffect(() => {
    setFormValues((prev) => ({
      ...prev,
      ID: nextKey,
      startPort: null,
      zielPort: null,
    }));
  }, [nextKey]);

  useEffect(() => {
    sessionStorage.setItem("KabelFastForm", JSON.stringify(formValues));
  }, [formValues]);

  const errorCb = () => {
    showErrorMessage(t("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    const payload = {
      mandant: client,
      program: program,
      statement: "KABEL_ERSTELLEN",
      formValues: formValues,
    };

    apiRequest("POST", "daten", payload, headers, submitCb, errorCb);
  };

  const submitCb = (response) => {
    if (response.status === 200) {
      setNextKey(response.data.nextKey);
      showSuccessMessage("Änderungen erfolgreich gespeichert");
    } else {
      showErrorMessage(response.data.message);
    }
  };

  const handleChange = (event, newValue, newName) => {
    const { name, value } = event.target;
    if (name) {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (newValue?.key) {
      setFormValues({ ...formValues, [newName]: newValue?.key });
    }
  };

  const clearForm = () => {
    setFormValues({
      ID: nextKey,
      startStandort: null,
      startRaum: null,
      startEinheit: null,
      startKategorie: null,
      startFhw: null,
      startPort: null,
      zielStandort: null,
      zielRaum: null,
      zielEinheit: null,
      zielKategorie: null,
      zielFhw: null,
      zielPort: null,
      art: null,
      laenge: "00.0",
      startStecker: null,
      zielStecker: null,
      spez: null,
      virtuell: "0",
    });
  };

  return (
    <>
      {!isLoading && formValues && (
        <Dialog fullWidth={true} maxWidth="lg" open={open} onClose={handleClose}>
          <DialogTitle>{t("Schnell Kabel erstellen")}</DialogTitle>
          {showInfo && (
            <Alert severity="info" variant="outlined" onClose={hideInfo} sx={{ mb: 2 }}>
              <AlertTitle>{t("Tipp")}</AlertTitle>
              {t(
                "Dieser Dialog übernimmt große Teile deiner letzten Eingabe. Wenn du mehrere sehr ähnliche Kabel erstellen möchtest, kannst du sie daher bequem nacheinander anlegen.",
              )}
            </Alert>
          )}

          <DialogContent>
            <form onSubmit={handleSubmit} id="edit-form">
              <Typography>{t("Nächste freie ID: ") + nextKey}</Typography>
              <FormTextField label="Kabel ID" indexKey={"ID"} required formValues={formValues} handleChange={handleChange} />

              <Typography sx={{ paddingTop: 2, fontWeight: "bold" }}>{t("Kabel Start")}</Typography>
              <Divider sx={{ borderBottomWidth: 5 }} component="div" />

              <FormAutoComplete
                label="Start Standort"
                indexKey={"startStandort"}
                options={standortOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormAutoComplete
                label="Start Raum"
                indexKey={"startRaum"}
                options={standortOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormAutoComplete
                label="Start Einheit"
                indexKey={"startEinheit"}
                options={einheitenOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormAutoComplete
                label="Start Kategorie"
                indexKey={"startKategorie"}
                options={kategorieOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormAutoComplete
                label="Start Gerät"
                indexKey={"startFhw"}
                options={deviceOptionsStart}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormTextField label="Start Port" indexKey={"startPort"} required disabled={disabled} formValues={formValues} handleChange={handleChange} />
              <FormAutoComplete
                label="Start Stecker"
                indexKey={"startStecker"}
                options={steckerOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />

              <Typography sx={{ paddingTop: 2, fontWeight: "bold" }}>{t("Kabel Ziel")}</Typography>
              <Divider sx={{ borderBottomWidth: 5 }} component="div" />

              <FormAutoComplete
                label="Ziel Stanrdort"
                indexKey={"zielStandort"}
                options={standortOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormAutoComplete
                label="Ziel Raum"
                indexKey={"zielRaum"}
                options={standortOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormAutoComplete
                label="Ziel Einheit"
                indexKey={"zielEinheit"}
                options={einheitenOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormAutoComplete
                label="Ziel Kategorie"
                indexKey={"zielKategorie"}
                options={kategorieOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormAutoComplete
                label="Ziel Gerät"
                indexKey={"zielFhw"}
                options={deviceOptionsZiel}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
              <FormTextField label="Ziel Port" indexKey={"zielPort"} required disabled={disabled} formValues={formValues} handleChange={handleChange} />
              <FormAutoComplete
                label="Ziel Stecker"
                indexKey={"zielStecker"}
                options={steckerOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />

              <Typography sx={{ paddingTop: 2, fontWeight: "bold" }}>{t("Kabel Infos")}</Typography>
              <Divider sx={{ borderBottomWidth: 5 }} component="div" />

              <FormAutoComplete
                label="Kabel Art"
                indexKey={"art"}
                options={artenOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />

              <FormNumField label="Kabel Länge (in Metern)" indexKey={"laenge"} formValues={formValues} disabled={disabled} setFormValues={setFormValues} />

              <FormAutoComplete
                label="Spezifikation"
                indexKey={"spez"}
                options={spezOptions}
                required
                disabled={disabled}
                formValues={formValues}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />

              <FormAutoComplete
                label="Virtuelles Kabel"
                indexKey={"virtuell"}
                options={virtuellOptionen}
                formValues={formValues}
                disabled={disabled}
                setFormValues={setFormValues}
                dialogVersion={dialogVersion}
              />
            </form>
          </DialogContent>

          <DialogActions>
            <>
              <Button variant="outlined" color="secondary" onClick={clearForm}>
                {t("Leeren")}
              </Button>
              <Button variant="outlined" color="secondary" onClick={handleClose}>
                {t("Abbrechen")}
              </Button>
              <Button variant="contained" color="primary" type="submit" form="edit-form">
                {t("Speichern")}
              </Button>
            </>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
